import React from 'react';

const DashboardHome = () => {
    return (
        <div class="flex items-center justify-center h-full">
            <img
                src="/logo_down_nb.png" // Reference the logo from the public folder
                alt="StockEasy Logo"
                class="w-150"
            />
        </div>
    );
};

export default DashboardHome;